export default {
  MAILING_BOUNCE_EXCEEDED_LIMIT: 50,
  MAILING_COMPLAINT_EXCEEDED_LIMIT: 4,
  RESERVED_DOMAINS: ['in', 'e', 'static-api', 'console', 'status', 'pay', 'show', 'docs', 'magic-demo'],
  MAXIMUM_QUANTITY_PER_TICKET_TYPE: 10,
};
